<template>
    <div>
        <div class="title">
            <h1> 其他了解我的方式 </h1>
        </div>
        <div class="content">
            <el-row>
                <el-col :span="2"><div class="grid-content"></div></el-col>
                <el-col :span="6" >
                    <div class="grid-content">
                        <div class="image-salon"></div>
                    </div>
                </el-col>
                <el-col :span="14" style="height: 20vw">
                    <div class="grid-content content-text">
                        <h1>学术沙龙分享</h1>
                        <h2>
                            我曾受邀于未来设计论坛上做了名为我们与“头号玩家”的距离：触觉重塑虚拟现实感知边界的学术沙龙分享。
                        </h2>
                        <div class="BTN">
                            <a target="_blank" href="https://www.yuque.com/ogongqingo/fac2z4/flanr5gvwq0k498n">
                                <input class="detailBTN" type="button" value="了解更多">
                            </a>
                        </div>
                    </div>
                </el-col>
                <el-col :span="2"><div class="grid-content"></div></el-col>
            </el-row>
        </div>
        <div class="content">
            <el-row>
                <el-col :span="2"><div class="grid-content"></div></el-col>
                <el-col :span="6" >
                    <div class="grid-content">
                        <div class="image1"></div>
                    </div>
                </el-col>
                <el-col :span="14" style="height: 20vw">
                    <div class="grid-content content-text">
                        <h1>设计研究主题公开演讲</h1>
                        <h2>
                            我曾受邀在“21设计”平台就设计研究相关主题进行公开分享。“21设计”是由中国机械工程学会工业设计分会支持的公益交流平台，聚焦前沿设计议题，邀请具备研究成果的学者进行经验分享，也持续帮助对设计研究感兴趣的青年共同成长。
                        </h2>
                        <div class="BTN">
                            <a target="_blank" href="https://www.yuque.com/ogongqingo/fac2z4/hrg5ck">
                                <input class="detailBTN" type="button" value="了解更多">
                            </a>
                        </div>
                    </div>
                </el-col>
                <el-col :span="2"><div class="grid-content"></div></el-col>
            </el-row>
        </div>
        <div class="content">
            <el-row>
                <el-col :span="2"><div class="grid-content"></div></el-col>
                <el-col :span="6" >
                    <div class="grid-content">
                        <div class="image3"></div>
                    </div>
                </el-col>
                <el-col :span="14" style="height: 20vw">
                    <div class="grid-content content-text">
                        <h1>技术开发经验分享</h1>
                        <h2> 我在哔哩哔哩个人账号发布了多个与 VR 眼动追踪和注视点渲染相关的开发视频，并在语雀平台整理了配套开发文档。这些内容帮助了不少开发者和技术爱好者，也获得了积极反馈。</h2>
                        <div class="BTN">
                            <a target="_blank" href="https://www.bilibili.com/video/BV1FL41157F2/?spm_id_from=333.999.0.0&vd_source=95cb2f19566155bb73393c4156455e36">
                                <input class="detailBTN" type="button" value="哔哩哔哩">
                            </a>
                            <a target="_blank" href="https://www.yuque.com/ogongqingo/fac2z4/yu9vb3">
                                <input class="detailBTN" type="button" value="语雀文档">
                            </a>
                        </div>
                    </div>
                </el-col>
                <el-col :span="2"><div class="grid-content"></div></el-col>
            </el-row>
        </div>
    </div>
</template>

<script>
    export default {
        name: "MediaZh"
    }
</script>

<style scoped>
    h1{
        font-size: 25px;
        font-weight: 400;
        color: #333;
    }
    h2{
        font-size: 15px;
        font-weight: 100;
        line-height: 25px;
        color: #666;
    }
    .BTN{

    }
    .detailBTN{
        margin-right: 10px;
        margin-top: 2px;
        cursor:pointer;
        width: 150px;
        height: 50px;
        background-color: #333;
        color: #fff;
        border: none;
    }
    .detailBTN:hover{
        opacity: 80%;
    }
    .content{
        margin-top: 100px;
        width: 100%;
        height: 20vw;
    }
    .content-text{
        margin-left: 4vw;
        margin-top: -25px;
    }
    .image-salon{
        width: 100%;
        height: 20vw;
        background-color: #000;
        background-image: url("../assets/media3.jpeg.webp");
        background-position: center;
        background-repeat: no-repeat;
        background-size: contain;
    }
    .image1{
        width: 100%;
        height: 20vw;
        background-image: url("../assets/publicspeaking.jpg.webp");
        background-position: center;
        background-size: cover;
    }
    .image2{
        width: 100%;
        height: 20vw;
        background-image: url("../assets/blog.png.webp");
        background-position: center;
        background-size: cover;
    }
    .image3{
        width: 100%;
        height: 20vw;
        background-image: url("../assets/vreye_homepage.jpg.webp");
        background-position: center;
        background-size: cover;
    }
    .grid-content{
        min-height: 36px;
    }
    .title{
        margin-top: 100px;
        text-align: center;

    }
    .title a{
        color: #333;
    }
    .title p{
        color: #aaa;
        line-height: 30px;
    }
    .title h1{
        font-size:30px;
        font-weight: 100;
        letter-spacing:6px;
        color: #333333;
    }
</style>